import { isStringEmptyOrNull } from "../../../../utils/common";
import moment from 'moment';
import { MSG_EMPTY_REQUIRED, MSG_GREATER_ENDDATE, MSG_EXCEEDS_CHARACTER, MSG_GREATER_ZERO, MSG_PASSWORD_LEAST_SIX, MSG_EXCEED_NUMBER } from "../../../../utils/messages";

export const validateForm = (values) => {
    let errors = {};

    
    if (isStringEmptyOrNull(values.StoreModel.storeName)) {
        errors[`StoreModel.storeName`] = MSG_EMPTY_REQUIRED;
    } else if(125 < values.StoreModel.storeName.length){
        errors[`StoreModel.storeName`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.StoreModel.storeCode)) {
        errors[`StoreModel.storeCode`] = MSG_EMPTY_REQUIRED;
    } else if(50 < values.StoreModel.storeCode.length){
        errors[`StoreModel.storeCode`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.StoreModel.storeDescription)) {
        errors[`StoreModel.storeDescription`] = MSG_EMPTY_REQUIRED;
    } else if(255 < values.StoreModel.storeDescription.length){
        errors[`StoreModel.storeDescription`] = MSG_EXCEEDS_CHARACTER;
    }

    if (moment(values.StoreModel.endDate).isBefore(moment(values.StoreModel.startDate))) {
        errors[`StoreModel.endDate`] = MSG_GREATER_ENDDATE;
    }

    if (0 >= Number(values.StoreModel.storeSponsorship.value) || 0 >= Number(values.StoreModel.storeSponsorship)) {
        errors[`StoreModel.storeSponsorship`] = MSG_GREATER_ZERO;
    }else if(99999999999 < Number(values.StoreModel.storeSponsorship.value)){
        errors[`StoreModel.storeSponsorship`] = MSG_EXCEED_NUMBER;
    }

    if (isStringEmptyOrNull(values.StoreModel.storeUsername)) {
        errors[`StoreModel.storeUsername`] = MSG_EMPTY_REQUIRED;
    }

    if (isStringEmptyOrNull(values.StoreModel.storePassword)) {
        errors[`StoreModel.storePassword`] = MSG_EMPTY_REQUIRED;
    }else if(6 > values.StoreModel.storePassword.trim().length){
        errors[`StoreModel.storePassword`] = MSG_PASSWORD_LEAST_SIX;
    }

    return errors;
    
}